import { render } from "./AccordionTransition.vue?vue&type=template&id=0bf11ddf"
import script from "./AccordionTransition.vue?vue&type=script&lang=js"
export * from "./AccordionTransition.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__